export const PAYMENT_LINKS_WRITE = 'payment-links-write';
export const INVOICES_WRITE = 'invoices-write';
export const QUOTE_CREATE = 'quote-create';